import PropTypes from 'prop-types';
import { useState } from 'react';
import { Icon } from '@iconify/react';

import {
  Box,
  Card,
  Container,
  Link,
  Typography,
  BottomNavigation,
  BottomNavigationAction
} from '@mui/material';
// material
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from '../common/LocalizationProvider';

import { MHidden } from '../components/@material-extend';
import { RegisterWithClubForm, RegisterForm } from '../components/authentication/register';
// components
import Page from '../components/Page';
// layouts
import AuthLayout from '../layouts/AuthLayout';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  backgroundColor: theme.palette.primary.main
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

// ----------------------------------------------------------------------

export default function Register() {
  const t = useTranslation();
  const [valueTabs, setValueTabs] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
  };
  return (
    <RootStyle title={t('RG_Title')}>
      <AuthLayout>
        {t('RG_AuthLayout')}&nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
          {t('RG_AuthLayout_Login')}
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <img src="/static/logo.svg" alt="CTO logo" width={160} />
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }} color="white" textAlign="center">
            {t('RG_Quote')}
          </Typography>
          <Typography variant="subtitle1" color="white">
            {t('RG_Quote_Author')}
          </Typography>
        </SectionStyle>
      </MHidden>

      <Container>
        <ContentStyle>
          <BottomNavigation value={valueTabs} onChange={handleChangeTabs} showLabels>
            <BottomNavigationAction
              label={t('RG_Tab_O')}
              icon={<Icon icon="fluent-emoji-high-contrast:man-pilot" width={24} height={24} />}
              sx={{ ml: 2 }}
            />
            <BottomNavigationAction
              label={t('RG_Tab_1')}
              icon={<Icon icon="carbon:location-company" width={24} height={24} />}
              sx={{ ml: 2 }}
            />
          </BottomNavigation>

          <Box sx={{ mt: 5 }}>
            <TabPanel value={valueTabs} index={0}>
              <RegisterForm />

              <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
                {t('RG_Terms_Title')}&nbsp;
                <Link
                  underline="always"
                  sx={{ color: 'text.primary' }}
                  onClick={() => window.open('https://clickandtakeoff.com/condition-dutilisation/')}
                >
                  {t('RG_Terms_Link')}
                </Link>
                .
              </Typography>
            </TabPanel>
            <TabPanel value={valueTabs} index={1}>
              <Box sx={{ mb: 5 }}>
                <Typography variant="h4" gutterBottom>
                  {t('RG_Subtitle_1')}
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>{t('RG_Subtitle_2')}</Typography>
              </Box>

              <RegisterWithClubForm />

              <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
                {t('RG_Terms_Title')}&nbsp;
                <Link
                  underline="always"
                  sx={{ color: 'text.primary' }}
                  onClick={() => window.open('https://clickandtakeoff.com/condition-dutilisation/')}
                >
                  {t('RG_Terms_Link')}
                </Link>
                .
              </Typography>
            </TabPanel>
          </Box>

          <MHidden width="smUp">
            <Typography variant="subtitle2" sx={{ mt: 3, textAlign: 'center' }}>
              {t('RG_AuthLayout')}&nbsp;
              <Link to="/login" component={RouterLink}>
                {t('RG_AuthLayout_Login')}
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
